export default "__VITE_ASSET__DWs$Knds__"